export default [
	{
		path: '/image',
		name: 'ImageLibrary',
		component: () => import('@/views/image/ImageLibrary.vue'),
		meta: {
			layout: 'Default',
		}
	},
]